<template>
  <select-create
    :model="model"
    :columns="columns"
    :api="api"
    createApi="Parts/Create"
    :createModel="formModel"
    :selected="selected"
    :fields="{id: 'id', title: 'partNumber'}"
    :templateFilter="templateFilter"
    v-bind="$attrs"
    :canCreate="canCreate"
    v-on="$listeners"
    @validate="handlerValidate"
  >
    <template v-slot:form="{ change, data }">
      <create-form ref="form" :model="formModel" :data="data" @change="change"></create-form>
    </template>
  </select-create>
</template>

<script>
const L10n = window.app.L10n
export default {
  name: 'SelectPartNumber',
  components: {
    'select-create': () => import(/* webpackChunkName: 'Shared' */ '@/components/Form/UI/Selects/SelectCreate/Index'),
    'create-form': () => import(/* webpackChunkName: 'Shared' */ './Form.vue')
  },
  props: {
    model: { required: true },
    api: { type: String, default: 'Parts/GetAllDynamic' },
    selected: { type: String, default: 'id,partNumber,partDescription,remark' },
    fields: { id: 'id', title: 'partNumber' },
    columns: {
      type: Array,
      default: () => (
        [
          { title: L10n('part-number'), value: 'partNumber' },
          { title: L10n('part-description'), value: 'partDescription' },
          { title: L10n('remark'), value: 'remark' }
        ]
      )
    },
    createPermission: { type: String, default: 'isAllowToEditParts' }
  },
  computed: {
    permissions () {
      return this.$store.getters.get('permissions')
    },
    canCreate () {
      return this.permission(this.permissions, this.createPermission)
    }
  },
  methods: {
    templateFilter (data) {
      return data.search ? `partNumber.StartsWith("${data.search}")` : null
    },
    formModel () {
      return {
        partNumber: '',
        partDescription: '',
        manufacturerID: null,
        aircraftID: null,
        listPrice: '',
        listPriceDate: null,
        remark: '',
        technicalRemark: ''
      }
    },
    handlerValidate (callback) {
      this.$refs.form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('invalid part form'))
        })
    }
  }
}
</script>
